// import the react components
import React from "react";

// import the dayjs components
import dayjs from "dayjs";

// import the icons
import {FaChevronLeft} from "react-icons/fa";
import {FaChevronRight} from "react-icons/fa";

// import the context
import {useStateContext} from "./../../context/";

// the calendar header functional based component
const CalendarHeader = () => {
    const {month_index, set_month_index} = useStateContext();

    // handle the click events
    const handle_preview_month = () => set_month_index(month_index -1);
    const handle_next_month = () => set_month_index(month_index + 1);
    const handle_reset = () => set_month_index(dayjs().month());

    // the current date
    const current_date = dayjs(new Date(dayjs().year(), month_index)).format("MMMM YYYY");

    // return to the component data
    return (
        <header className="flex flex-col gap-3 pb-3">
            <div className="flex items-center justify-between flex-wrap gap-2">
                <div className="flex items-center gap-1.5">
                    <button onClick={handle_reset} className="h-[35px] px-4 text-md font-medium rounded-lg border border-gray-200 dark:border-gray-700 text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors">Today</button>
                    <button onClick={handle_preview_month} aria-label="Previous month" className="w-[30px] h-[35px] flex items-center justify-center rounded-lg border border-gray-200 dark:border-gray-700 text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"><FaChevronLeft className="text-xs" /></button>
                    <span className="w-32 text-center text-md font-medium text-gray-900 dark:text-gray-50">{current_date}</span>
                    <button onClick={handle_next_month} aria-label="Next month" className="w-[30px] h-[35px] flex items-center justify-center rounded-lg border border-gray-200 dark:border-gray-700 text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"><FaChevronRight className="text-xs" /></button>
                </div>
            </div>
        </header>
    );
};
export default CalendarHeader;